"use strict";

import _get from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _classCallCheck from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { arrayify, hexlify } from "@ethersproject/bytes";
import { Coder } from "./abstract-coder";
export var DynamicBytesCoder = /*#__PURE__*/function (_Coder) {
  _inherits(DynamicBytesCoder, _Coder);

  function DynamicBytesCoder(type, localName) {
    _classCallCheck(this, DynamicBytesCoder);

    return _possibleConstructorReturn(this, _getPrototypeOf(DynamicBytesCoder).call(this, type, type, localName, true));
  }

  _createClass(DynamicBytesCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      value = arrayify(value);
      var length = writer.writeValue(value.length);
      length += writer.writeBytes(value);
      return length;
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return reader.readBytes(reader.readValue().toNumber());
    }
  }]);

  return DynamicBytesCoder;
}(Coder);
export var BytesCoder = /*#__PURE__*/function (_DynamicBytesCoder) {
  _inherits(BytesCoder, _DynamicBytesCoder);

  function BytesCoder(localName) {
    _classCallCheck(this, BytesCoder);

    return _possibleConstructorReturn(this, _getPrototypeOf(BytesCoder).call(this, "bytes", localName));
  }

  _createClass(BytesCoder, [{
    key: "decode",
    value: function decode(reader) {
      return reader.coerce(this.name, hexlify(_get(_getPrototypeOf(BytesCoder.prototype), "decode", this).call(this, reader)));
    }
  }]);

  return BytesCoder;
}(DynamicBytesCoder);